// extracted by mini-css-extract-plugin
module.exports = {"container":"AppBadges_container__nNA4N"};